export type GetStyleGuidesRequest = {
    teamId: number;
    languages?: number[];
    name?: string;
    projectId?: string;
};

export type Language = {
    id: number;
    label: string;
    isoCode: string;
};

export type Project = {
    id: string;
    name: string;
};

export enum StyleGuideStates {
    uninitialized = 'uninitialized',
    inProgress = 'inProgress',
    contentError = 'contentError',
    downloadFailed = 'downloadFailed',
    tokenLimitExceeded = 'tokenLimitExceeded',
    promptSizeLimitExceeded = 'promptSizeLimitExceeded',
    languageError = 'languageError',
    promptError = 'promptError',
    generalError = 'generalError',
    synced = 'synced',
}

export type StyleGuide = {
    id: string;
    name: string;
    language: Language | null;
    projects: Project[];
    createdAt: string;
    createdBy: {
        name: string;
        gravatarHash: string;
    };
    summary: {
        status: StyleGuideStates;
        text: string;
    };
};

export type LanguagesResponse = Language[];
export type ProjectsResponse = Project[];

export type StyleGuideResponse = StyleGuide[];

export type StyleGuideEdit = {
    id: string;
    languageId?: number;
    projects?: string[];
    summary?: string;
    name?: string;
};

export type EditStyleGuideRequest = {
    teamId: number;
    styleGuides: StyleGuideEdit[];
};

export type DeleteStyleGuideRequest = {
    teamId: number;
    styleGuideId: string;
};

export type DownloadStyleGuideRequest = {
    teamId: number;
    styleGuideId: string;
};
